module.exports = __webpack_public_path__ + "img/visitor_default_prod.700cf6bc.jpg";